<template>
  <div class="index">
    <router-view v-wechat-title="$route.meta.title"></router-view>
    <div>目录</div>
    <ul class="menu">
      <li class="head">
        <router-link to="/">了解徐馆</router-link>
      </li>
      <li>
        <router-link to="/synopsis/jng_gk">----纪念馆概况</router-link>
      </li>
      <li>
        <router-link to="/synopsis/exhibition_zl">----展览欣赏</router-link>
      </li>
      <li>
        <router-link to="/synopsis/visit_service">----参观服务</router-link>
      </li>
      <li>
        <router-link to="/synopsis/order_service">----预约服务</router-link>
      </li>
    </ul>

    <ul class="menu">
      <li class="head">
        <router-link to="/">走进徐馆</router-link>
      </li>
      <li>
        <router-link to="/service/order/entry">----门票预约</router-link>
      </li>
      <li>
        <router-link to="/service/activity_yy">----活动预约</router-link>
      </li>
      <li>
        <router-link to="/service/questionnaire">----问卷调查</router-link>
      </li>
      <li>
        <router-link to="/service/opinion">----意见反馈</router-link>
      </li>
      <!--<li>
                <router-link to="/service/activity_zj">&#45;&#45;&#45;&#45;展教活动</router-link>
      </li>-->
    </ul>

    <ul class="menu">
      <li class="head">
        <router-link to="/">品读徐馆</router-link>
      </li>
      <li>
        <router-link to="/tour/online">----徐馆导赏</router-link>
      </li>
      <!-- <li>
        <a href="https://www.xbhjng.com/wx/beacons_xbh/main.php?floor_i=0">----馆内地图</a>
      </li> -->
      <li>
        <router-link to="/tour/online/map">----馆内地图</router-link>
      </li>
      <li>
        <router-link to="/tour/commodity">----文创产品</router-link>
      </li>
      <li>
        <router-link to="/service/yaoyiyao">----摇一摇</router-link>
      </li>
    </ul>

    <ul class="menu">
      <li class="head">
        <router-link to="/">个人中心</router-link>
      </li>
      <li>
        <router-link to="/userinfo">----我的预约</router-link>
      </li>
    </ul>
    <div class="token">
            <input type="text" v-model="email" placeholder="已注册的邮箱"/>
            <input type="text" v-model="password" placeholder="密码" @keyup.enter="getToken"/>
            <button @click="getToken">登录</button>
            <div v-if="api_token">已获取用户api_token:<br>{{api_token}}</div>
    </div>
    <!--<div class="token">
            <input type="text" v-model="email" placeholder="注册的邮箱"/>
            <input type="text" v-model="smscode" placeholder="验证码"/>
            <button @click="getSmsCode">获取验证码</button>
            <br/>
            <br/>
            <input type="text" v-model="password" placeholder="密码" @keyup.enter="getRegister"/>
            <button @click="getRegister">注册 </button>
    </div>-->
  </div>
</template>
<script>
export default {
  name: "index",
  data: function() {
    return {
      api_token: "",
      email: "",
      password: "",
      smscode: ""
    };
  },
  created: function() {},
  methods: {
    getToken: function() {
      var vm = this;
      vm.axios({
        method: "post",
        url: "/api/users/login",
        data: {
          p: "wx",
          email: vm.email,
          password: vm.password
        }
      })
        .then(function(rlt) {
          if (rlt.data.status == 1) {
            vm.api_token = rlt.data.data.api_token;
            localStorage.setItem("api_token", vm.api_token);
            vm.$store.commit("updateToken");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getSmsCode: function() {
      var vm = this;
      vm.axios({
        method: "post",
        url: "/api/send_vcode",
        data: {
          p: "w",
          email: vm.email,
          type: 1
        }
      })
        .then(function(rlt) {
          if (rlt.data.status == 1) {
            this.$Message.success("已发送");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getRegister: function() {
      var vm = this;
      vm.axios({
        method: "post",
        url: "/api/users/register",
        data: {
          p: "wx",
          email: vm.email,
          smscode: vm.smscode,
          password: vm.password
        }
      })
        .then(function(rlt) {
          if (rlt.data.status == 1) {
            this.$Message.success("已注册");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
.menu {
  padding: 0.5rem 1rem;
}

.menu li {
  font-size: 1rem;
  line-height: 200%;
}

.menu li.head {
  font-size: 1.2rem;
  font-weight: bold;
}

.token {
  padding: 2rem;
}

.token input {
  display: block;
  width: 100%;
  margin-bottom: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue